<p>payment-not-supported works!</p>
